const KB = 1024
const MB = KB * 1024
const GB = MB * 1024
const TB = GB * 1024

const currencySymbols: Record<string, string> = {
	usd: '$',
	inr: '₹',
	eur: '€',
}

export const getCurrencySymbol = (currency?: string | null): string => {
	if (!currency) return ''

	return currencySymbols[currency.toLowerCase()] ?? currency.toUpperCase()
}

export const formatStorageSize = (bytes: number | null): number => {
	if (bytes === null) return 0

	const value = bytes / TB

	return Number(value.toFixed(value < 1 ? 3 : 0))
}

export const formatTerabytesToBytes = (terabytes: number | null): number => {
	if (terabytes === null) return 0

	return Math.round(terabytes * TB)
}

export const formatDecimal = (value: number, maxFractionDigits = 2): string => {
	if (!Number.isFinite(value)) return '0'
	return String(Number(value.toFixed(maxFractionDigits)))
}

export const formatBytesToReadable = (bytes: number | null): string => {
	if (bytes === null) return '-'

	if (bytes < KB) return `${bytes} B`
	if (bytes < MB) return `${formatDecimal(bytes / KB)} KB`
	if (bytes < GB) return `${formatDecimal(bytes / MB)} MB`
	if (bytes < TB) return `${formatDecimal(bytes / GB)} GB`
	return `${formatDecimal(bytes / TB)} TB`
}
